import React from "react";
import { Link } from "react-router-dom";
import TrustScoreDial from "./TrustScoreDial";
import "../../styles/CardPages.css";

/* Shared "Want to build your Trust Score?" promo (Tom's HomeTest /
   NewPackagesPageTest mocks). The 85 is illustrative marketing copy —
   never render this section for a real contractor's profile. */

const BULLETS = [
  "Stand out from the competition with a verified profile badge.",
  "Submit quote evidence for review against modelled allowances.",
  "Attract customers who are after quality, not just the lowest price.",
];

const TrustScorePromoSection = ({ variant = "cardpage" }) => {
  const isHome = variant === "home";

  const content = (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
      <div
        className={`${isHome ? "order-2" : "order-2 lg:order-1"} flex flex-col justify-center min-w-0`}
      >
        <h2 className="feature-title text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-6 leading-tight tracking-tight">
          Want to build your{" "}
          <span className="text-[#10b981]">Trust Score?</span>
        </h2>
        <p className="feature-copy text-base md:text-lg text-gray-600 leading-relaxed mb-8">
          Improve your profile and give homeowners more confidence by becoming
          an accredited{" "}
          <strong className="pp-tsp-strong text-gray-900">
            Trusted by Percy
          </strong>{" "}
          tradesperson under Pricing Penguin's own scheme. Show the evidence
          available on your profile and the scope of any current award.
        </p>
        <ul className="space-y-5 mb-10">
          {BULLETS.map((line) => (
            <li
              key={line}
              className="feature-bullet flex items-start gap-4 text-gray-700 font-medium text-base md:text-lg"
            >
              <span className="pp-tsp-chip w-8 h-8 rounded-full bg-green-50 text-[#10b981] flex items-center justify-center shrink-0 mt-0.5 border border-green-100">
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </span>
              <span className="pt-1">{line}</span>
            </li>
          ))}
        </ul>
        <div className="flex flex-col sm:flex-row gap-4">
          <Link
            to="/trust-score"
            className="inline-flex justify-center items-center bg-[#10b981] hover:bg-[#059669] text-white px-8 py-4 rounded-xl font-bold text-lg transition-colors w-full sm:w-auto shadow-md"
          >
            Boost My Trust Score
          </Link>
          <Link
            to="/trusted-by-percy"
            className="pp-tsp-btn-dark inline-flex justify-center items-center bg-[#111827] hover:bg-gray-800 text-white px-8 py-4 rounded-xl font-bold text-lg transition-colors w-full sm:w-auto shadow-md"
          >
            Learn More
          </Link>
        </div>
      </div>

      <div
        className={`${isHome ? "order-1" : "order-1 lg:order-2"} w-full flex justify-center items-center min-w-0`}
      >
        <div className="py-4 transform hover:scale-105 transition-transform duration-500">
          <TrustScoreDial score={85} className="pp-tsp-dial" />
        </div>
      </div>
    </div>
  );

  if (isHome) {
    return (
      <section className="feature-panel bg-white border border-[#E8E8EC] rounded-[22px] p-6 md:p-10 lg:p-12">
        {content}
      </section>
    );
  }

  return (
    <section className="px-4 md:px-8">
      <div
        data-reveal
        className="max-w-7xl mx-auto bg-white rounded-[32px] p-8 md:p-16 shadow-sm border border-[#e3e7ee]"
      >
        {content}
      </div>
    </section>
  );
};

export default TrustScorePromoSection;
